import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'To' },
    { value: 2, label: 'Reduce' },
    { value: 3, label: 'Increase' },
  ],
});
